export default "__VITE_ASSET__a44680bb__"